import { Controller } from "@hotwired/stimulus"
import IMask from "imask"

// Constrains the username field to the handle ruleset (mirrors
// User::USERNAME_FORMAT): lowercase [a-z0-9] with single "." or "_" separators,
// no leading or consecutive separators. A lone trailing separator is allowed
// mid-typing since the next character completes it; length and reserved-word
// checks stay server-side. Uppercase is folded to lowercase as you type.
export default class extends Controller {
  connect() {
    this.mask = IMask(this.element, {
      mask: /^[a-z0-9]+(?:[._][a-z0-9]+)*[._]?$/,
      prepare: (value) => value.toLowerCase(),
    })
  }

  disconnect() {
    this.mask?.destroy()
  }
}
